import { TagsFindResponseBodyTagsDto } from './TagListTypes';
import { ReviewDetailCriteriaDto } from './ReviewCriteriaTypes';

export enum ReviewStatus {
  SUBMIT = 'submit',
  DELETED_FROM_USER = 'deleteFromUser',
  DELETED_FROM_ADMIN = 'deleteFromAdmin',
}

export type ReviewFindOneResponseBodyUserDto = {
  id: number;
  account: string;
  name: string;
};

export type ReviewFindOneResponseBodyReviewAttachmentDto = {
  id: number;
  url: string;
  createDate: string;
  updateDate: string;
};

export type ReviewFindOneResponseBodyOrderDto = {
  id: string;
  buyerAccount: string;
  buyerName: string;
};

export type ReviewFindOneResponseBodyPointReturnedDto = {
  amount: number;
  pointIssueHistoryId: number;
  adminId: number;
  memo: string;
};

export type ReviewFindOneResponseBodyReviewDto = {
  id: number;
  productId: number;
  rate: number;
  content: string;
  createDate: string;
  updateDate: string;
  orderItemId: string;
  receivedPointAmount: number;
  status: ReviewStatus;
  isReported: boolean;
  user: ReviewFindOneResponseBodyUserDto;
  reviewAttachments: ReviewFindOneResponseBodyReviewAttachmentDto;
  reviewTags: TagsFindResponseBodyTagsDto;
  reviewCriteria: ReviewDetailCriteriaDto[];
  order: ReviewFindOneResponseBodyOrderDto;
  pointReturned: ReviewFindOneResponseBodyPointReturnedDto;
};

export type ReviewFindOneResponseBodyDto = {
  review: ReviewFindOneResponseBodyReviewDto;
};
